import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { connect } from 'trim-redux';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import BannerItem from './BannerItem';
import MakeBannerButton from './MakeBannerButton';
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import {defaultVariables} from "../../../../../config";

const useStyles = makeStyles((theme) => ({
    ...theme.styles,
}));

const BannersManager = ({ position, model, limit, locale, page}) => {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);

    const tableRef = useRef();

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const loginToken = localStorage.getItem('ACT');
        if (loginToken) {
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            };
            try {
                const response = await axios.get(`${defaultVariables.url}/banners/get-all/${position}`, config);
                setItems(response.data);
            } catch (error) {
                console.error(error.response);
            } finally {
                setLoading(false);
            }
        } else {
            console.error('Authentication required.');
        }
    };

    return (
        <>
            {loading ? (
                <AppCardLoaderFields />
            ) : (
                <Grid container spacing={2} alignItems="center">
                    {items.map((item, index) => (
                        <Grid
                            key={index}
                            item
                            size={{xs:6,md:4,lg:3}}
                        >
                            <BannerItem position={position} item={item} reload={loadData} model={model} page={page}/>
                        </Grid>
                    ))}
                    {(!limit || limit > items.length) && (
                        <Grid item size={{xs:6,md:4,lg:3}}>
                            <MakeBannerButton position={position} model={model} reload={loadData} page={page}/>
                        </Grid>
                    )}
                </Grid>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(BannersManager);
